import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { updateAllNegotiationTerms } from "../../../thunks/common-thunks/commonThunk";

const initialState = {
  isNegotiationLoading: false,
  error: null,
  negotiationTerms: null,
};

export const NegotiationTerms = createSlice({
  name: "negotiationTerms",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateAllNegotiationTerms.pending, (state) => {
        state.isNegotiationLoading = true;
        state.error = null;
      })
      .addCase(updateAllNegotiationTerms.fulfilled, (state, action) => {
        state.isNegotiationLoading = false;
        state.negotiationTerms = action.payload;
        if (action.payload?.status == 1) {
          message.success(action.payload.message);
        } else {
          message.error(action.payload.message);
        }
      })
      .addCase(updateAllNegotiationTerms.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default NegotiationTerms.reducer;
